// Device clock vs server clock (Guide §10.7): clientTs of every operation uses the corrected time, offset = median of the last 5 server times.
import { CLOCK_OFFSET_SAMPLES } from '@dd/shared';
import { hasDb, metaGet, metaSet } from '@/db';

let offsetMs = 0;
let samples: number[] = [];

export async function loadClock(): Promise<void> {
  if (!hasDb()) { samples = []; offsetMs = 0; return; } // before login / shop selection there is no shop database yet
  samples = (await metaGet<number[]>('clockSamples').catch(() => undefined)) ?? [];
  offsetMs = median(samples);
}
const median = (a: number[]): number => {
  if (!a.length) return 0;
  const s = [...a].sort((x, y) => x - y);
  const m = Math.floor(s.length / 2);
  return s.length % 2 ? s[m]! : Math.round((s[m - 1]! + s[m]!) / 2);
};
export async function sampleServerTime(serverTime: string, sentAt: number, receivedAt: number): Promise<void> {
  const mid = (sentAt + receivedAt) / 2;
  samples = [...samples, new Date(serverTime).getTime() - mid].slice(-CLOCK_OFFSET_SAMPLES);
  offsetMs = median(samples);
  try { await metaSet('clockSamples', samples); } catch { /* db closing */ }
}
export const clockOffset = (): number => offsetMs;
export const nowMs = (): number => Date.now() + offsetMs;
export const nowIso = (): string => new Date(nowMs()).toISOString();
/** true when the phone's clock is far enough off to confuse reports (shown as a warning) */
export const clockSkewed = (): boolean => Math.abs(offsetMs) > 5 * 60_000;
